import axios from 'axios'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { constants } from '../../Constants'
import { useEventContext } from '../../context/EventContext'
import { Button, Modal } from '../ui'
import { ModalCreateCategories } from './ModallCreateCategories'

export const ModalAddEvent = ({
  triggerLabel = 'Añadir Clase',
  triggerVariant = 'link',
  triggerStyle = { color: 'white' },
  onCreated,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [title, setTitle] = useState('')
  const [start, setStart] = useState('')
  const [end, setEnd] = useState('')
  const [color, setColor] = useState('#3182ce')
  const [categoryId, setCategoryId] = useState('')
  const [categories, setCategories] = useState([])
  const [selectedCategory, setSelectedCategory] = useState('')
  const { updateEvents } = useEventContext()

  // Crear clase es solo para administradores
  const localUser = JSON.parse(localStorage.getItem('user') || 'null')
  const isAdmin = localUser?.role === 'admin'

  const resetFields = () => {
    setTitle('')
    setStart('')
    setEnd('')
    setColor('#3182ce')
    setSelectedCategory('')
  }
  const handleClose = () => {
    resetFields()
    setIsOpen(false)
  }

  const loadCategories = async () => {
    try {
      const response = await axios.get(`${constants.urlLocal}categories/getAll`)
      setCategories(response.data.categories || [])
    } catch (error) {
      console.error('Error al cargar las categorías', error)
    }
  }

  useEffect(() => {
    if (isOpen) loadCategories()
  }, [isOpen])

  const handleSubmit = async e => {
    e.preventDefault()
    if (!title || !start || !end) return
    try {
      const response = await axios.post(`${constants.urlLocal}events/create`, {
        title,
        start,
        end,
        color,
        categoryId,
      })
      if (response.data.ok) {
        updateEvents()
        if (onCreated) onCreated()
        handleClose()
      }
    } catch (error) {
      console.error(
        'Error en la creación del clase: ',
        error.response?.data?.message || error.message
      )
    }
  }

  const handleStartChange = e => {
    const startTime = moment(e.target.value).local().format('YYYY-MM-DDTHH:mm')
    setStart(startTime)
    if (startTime) {
      setEnd(
        moment(startTime).add(1, 'hours').local().format('YYYY-MM-DDTHH:mm')
      )
    } else {
      setEnd('')
    }
  }

  // No mostrar nada a usuarios que no sean administradores
  if (!isAdmin) return null

  return (
    <>
      <Button
        variant={triggerVariant}
        onClick={() => setIsOpen(true)}
        style={triggerStyle}
      >
        {triggerLabel}
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        title="Añadir una nueva clase"
      >
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Categoría</label>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <select
                className="form-select"
                value={selectedCategory}
                onChange={e => {
                  const opt = e.target.options[e.target.selectedIndex]
                  setSelectedCategory(e.target.value)
                  setTitle(e.target.value)
                  setColor(opt.dataset.color || '#3182ce')
                  setCategoryId(opt.dataset.id || '')
                }}
              >
                <option value="">Selecciona una categoría</option>
                {categories.map(c => (
                  <option
                    key={c._id}
                    value={c.name}
                    data-color={c.color}
                    data-id={c._id}
                  >
                    {c.name}
                  </option>
                ))}
              </select>
              <ModalCreateCategories loadCategories={loadCategories} />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Título</label>
            <input
              className="form-input"
              value={title}
              onChange={e => setTitle(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Inicio</label>
            <input
              className="form-input"
              type="datetime-local"
              value={start}
              onChange={handleStartChange}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Fin</label>
            <input
              className="form-input"
              type="datetime-local"
              value={end}
              onChange={e => setEnd(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Color</label>
            <input
              className="form-color"
              type="color"
              value={color}
              onChange={e => setColor(e.target.value)}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '0.5rem',
              marginTop: '1rem',
            }}
          >
            <Button variant="ghost" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Crear Clase
            </Button>
          </div>
        </form>
      </Modal>
    </>
  )
}
